import { ReactNode } from "react";

const PageInner = ({ children }: { children: ReactNode }) => {
	return <div className="container">{children}</div>;
};

export default PageInner;
